// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

// Force translation files to refetch on each load so new keys
// don't get masked by stale browser-cached locale JSON.
const getTranslationLoadPath = (lngs, namespaces) => {
  const lng = Array.isArray(lngs) ? lngs[0] : lngs;
  const ns = Array.isArray(namespaces) ? namespaces[0] : namespaces;
  return `/locales/${lng}/${ns}.json?v=${Date.now()}`;
};

i18n
  // Tells i18next to load translations via HTTP from your public folder
  .use(HttpApi)
  // Automatically detect the user’s language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    load: "languageOnly",
    react: {
      useSuspense: false // Disable React Suspense
    },
    // Configure how i18next detects language (e.g., querystring, cookies, etc.)
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      lookupQuerystring: "lng", // If you use ?lng=fr
      caches: ["localStorage", "cookie"] // Optional, to remember the user’s chosen language
    },
    supportedLngs: ["en", "fr"],
    nonExplicitSupportedLngs: true,
    // Tells the HttpApi plugin where to find translation files
    backend: {
      // loadPath: where i18n will fetch translation JSON files
      // {{lng}} is your language code (en, fr, etc.)
      // {{ns}} is typically "translation" by default
      loadPath: getTranslationLoadPath
    },

    // React i18next special options (don’t escape already safe values)
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
